import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from '@cloudpremise/portal_core';

import { Provider } from 'react-redux';
import { store } from './store/store';
import { MaterialUIControllerProvider } from "@cloudpremise/portal_core/src/themes/mui/context";


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    // <React.StrictMode>
        <Provider store={store}>
            <MaterialUIControllerProvider>
                <App />
            </MaterialUIControllerProvider>
        </Provider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
